/**
 * Error thrown when the OpenAPI document is invalid.
 */
export class OpenAPIParseError extends Error {
    name = 'OpenAPIParseError';
    code;
    rootURL;
    errors;
    constructor(message, options) {
        super(message, { cause: options.cause });
        this.code = options.code;
        this.rootURL = options.rootURL ?? null;
        this.errors = options.errors;
    }
}
